import { IconAlertTriangle, IconFileX } from "@tabler/icons-react";
import { Alert, Card, Divider, Group, Stack, Text, ThemeIcon } from "@/components/ui";
import type { ReglaError } from "@/lib/types";
import {
  SolicitarAltaCatalogo,
  type TipoCatalogoSolicitud,
} from "@/features/solicitudes-catalogo/components/SolicitarAltaCatalogo";

/**
 * Card de errores de reglas de negocio (RN1-RN10) · presentacional.
 * Recibe la lista de errores ya extraída del resultado del upload.
 */
export function ReglasRechazadasCard({
  errores,
  solicitudId,
  numeroSolicitud,
}: {
  errores: ReglaError[];
  /** Para ligar la solicitud de catálogo (D-10) a la solicitud de pago. */
  solicitudId?: string;
  numeroSolicitud?: number;
}) {
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Group gap="sm" align="flex-start">
          <ThemeIcon variant="filled" color="multiva" size="lg">
            <IconFileX size={20} stroke={1.6} />
          </ThemeIcon>
          <div className="flex-1">
            <Text fw={600}>Reglas de negocio rechazadas</Text>
            <Text size="sm" c="dimmed">
              Corrige los errores y vuelve a cargar el CFDI.
            </Text>
          </div>
        </Group>
        <Divider />
        <Stack gap="xs">
          {errores.map((e, i) => (
            <Alert key={`${e.codigo}-${i}`} variant="error" icon={<IconAlertTriangle size={16} stroke={1.7} />}>
              <Stack gap={4}>
                <code className="self-start rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">{e.codigo}</code>
                <Text size="sm">{e.mensaje}</Text>
                {/* D-10 · el rechazo se resuelve dando de alta un elemento de catálogo. */}
                {e.catalogoFaltanteTipo && e.catalogoFaltanteClave && (
                  <SolicitarAltaCatalogo
                    tipo={e.catalogoFaltanteTipo as TipoCatalogoSolicitud}
                    clave={e.catalogoFaltanteClave}
                    solicitudPagoId={solicitudId}
                    numeroSolicitudPago={numeroSolicitud}
                  />
                )}
              </Stack>
            </Alert>
          ))}
        </Stack>
      </Stack>
    </Card>
  );
}
